import { useCallback } from "react";
import { toast, AgGrid } from "@jsq/ds/core";
import { useCancelComplianceInvitationMutation } from "~/graphql/supergraphHooks";
import { BaseCancelRequestModal } from "../../BaseCancelRequestModal";
import { BaseCancelRequestFormValues } from "../../BaseCancelRequestModal/types";

export type CancelRefreshRequestModalProps = {
  show: boolean;
  onHide: () => void;
  profileName: string;
  recipients: string[];
  invitationId: number;
  api?: AgGrid.GridApi;
};

export const CancelRefreshRequestModal = ({
  show,
  onHide,
  profileName,
  recipients,
  invitationId,
  api,
}: CancelRefreshRequestModalProps) => {
  const [cancelComplianceInvitation, { loading }] = useCancelComplianceInvitationMutation({
    fetchPolicy: "network-only",
    onCompleted: () => {
      api?.refreshServerSide({ purge: true });
      toast.success("Refresh request cancelled successfully");
      onHide();
    },
  });

  const handleCancel = useCallback(
    async (values: BaseCancelRequestFormValues) => {
      try {
        await cancelComplianceInvitation({
          variables: {
            invitationId,
            comment: values.comment || null,
            retainCase: values.caseRetention === "true",
          },
        });
      } catch {
        toast.error("Failed to cancel refresh request");
      }
    },
    [invitationId, cancelComplianceInvitation],
  );

  return (
    <BaseCancelRequestModal
      show={show}
      onHide={onHide}
      title="Cancel refresh request"
      subtitle={profileName}
      recipients={recipients}
      onCancel={handleCancel}
      loading={loading}
    />
  );
};
